import { render, staticRenderFns } from "./EditarItensVencedoresLoteLicitacao.vue?vue&type=template&id=7527c4ad"
import script from "./EditarItensVencedoresLoteLicitacao.vue?vue&type=script&lang=ts"
export * from "./EditarItensVencedoresLoteLicitacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports